/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';

import Layout from '../../../components/layout';
import SEO from '../../../components/common/seo';
import BlogNav from '../../../components/blocks/nav/blog-nav';
import Breadcrumbs from '../../../components/blocks/nav/breadcrumbs';
import SearchForm from '../../../components/common/search-form';
import Article from '../../../components/blocks/single/article';
import CategoryList from '../../../components/blocks/single/category-list';
import Share from '../../../components/blocks/single/share';
import RelatedPosts from '../../../components/blocks/single/related-posts';
import ImageWidgets from '../../../components/blocks/single/image-widgets';
import '../styles.sass';

const PostSingle = ({
  pageContext: {
    seo,
    homepageUrl,
    blogNavItems,
    article,
    categories,
    goal,
    postId,
    widgets,
    urlPath,
  },
}) => {
  return (
    <Layout>
      <SEO post={seo} />
      <Breadcrumbs
        homepageUrl={homepageUrl}
        items={[
          { capitalize: true, name: goal.name, urlPath: goal.urlPath },
          {
            name: article.title,
            urlPath,
          },
        ]}
      />
      <BlogNav items={blogNavItems} />
      <section className="block block__post-single has-sidebar">
        <div className="container">
          <section className="post-single__content">
            <Article article={article} />
            <CategoryList categories={categories} />
            <Share urlPath={urlPath} />
          </section>
          <section className="post-single__sidebar" role="complementary">
            <SearchForm />
            <RelatedPosts goal={goal} postId={postId} />
            <ImageWidgets widgets={widgets} />
          </section>
        </div>
      </section>
    </Layout>
  );
};

PostSingle.propTypes = {
  pageContext: PropTypes.shape({
    seo: PropTypes.object,
    homepageUrl: PropTypes.string,
    blogNavItems: PropTypes.array,
    article: PropTypes.shape({
      title: PropTypes.string,
    }),
    categories: PropTypes.object,
    goal: PropTypes.shape({
      name: PropTypes.string,
      urlPath: PropTypes.string,
    }),
    postId: PropTypes.number,
    widgets: PropTypes.array,
    urlPath: PropTypes.string,
  }).isRequired,
};

export default PostSingle;
